module.exports = __webpack_public_path__ + "static/media/smell.d997cf52.jpg";